import React, { useState, useRef, useEffect, useCallback } from 'react';

import { ToolbarForm } from '../../utils/toolbar-form/ToolbarForm';
import DataGrid, { Column, FilterRow, HeaderFilter, Scrolling, Editing,  SearchPanel, Selection } from 'devextreme-react/data-grid';

import ValidationGroup from 'devextreme-react/validation-group';

import './PermissiongroupForm.scss';
import classNames from 'classnames';
import { DateBox } from 'devextreme-react';
import { FormDateBox } from '../../utils/form-datebox/FormDateBox';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { checkPermission } from '../../../permissions';


export const PermissiongroupForm = ({ data, isLoading = false, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [permissiongroupData, setpermissiongroupData] = useState(data.permissiongroup);
  const [permissionsData, setpermissionsData] = useState(data.permissions);
   const [selectedRowKeys, setSelectedRowKeys] = useState(data.permissiongrouppermissions);
  const [dataSourceClub, setDataSourceClub] = useState(data.clubs);
  const [dataSourceTrainingGroup, setDataSourceTrainingGroup] = useState(data.traininggroups);
  const dataRef = useRef();
  const stylingMode = 'filled';

  useEffect(() => {
    setpermissiongroupData(data.permissiongroup);
    setpermissionsData(data.permissions);
    setSelectedRowKeys(data.permissiongrouppermissions);

  }, [data]);

  const handleEditClick = () => {
    if (editing === false && selectedRowKeys) {
      dataRef.current = selectedRowKeys;
    } else {
      dataRef.current = undefined;
    }
    setEditing(!editing);
  };

  const onSaveClick = ({ validationGroup }) => {
    handleEditClick();
    onSave(selectedRowKeys);
  };

  const onCancelClick = () => {
    setSelectedRowKeys(dataRef.current);
    handleEditClick();
  };


      const dataGridRef = useRef(null);
  
     
      const onSelectionChanged = useCallback(
        ({ selectedRowKeys: changedRowKeys, selectedRowsData }) => {
          setSelectedRowKeys(changedRowKeys);
        }, [],
      );
  return (
    <div className='permissiongroup-form'>
      <ValidationGroup>
        <ToolbarForm toggleEditing={handleEditClick} onSaveClick={onSaveClick} allowEditing={checkPermission('permission.edit')} editing={editing} onCancelClick={onCancelClick} />
        <DataGrid
          dataSource={permissionsData}
          showBorders={true}
          width="100%"
          height="100%"
          remoteOperations={true}
          visible={checkPermission('permission.list')}
          keyExpr="permissionId"
          onSelectionChanged={onSelectionChanged}
          ref={dataGridRef}
          selectedRowKeys={selectedRowKeys}
        >
          <FilterRow visible={true} />
          <HeaderFilter visible={false} />
          <SearchPanel visible={true} />
          <Scrolling mode="virtual" />
          <Selection mode={editing ? "multiple" : "none"} showCheckBoxesMode="always"  />
          <Editing
            mode="row"
            allowAdding={false}
            allowDeleting={false}
            allowUpdating={false}
          />
          <Column dataField="detail" caption="Name" sortIndex={7} sortOrder='asc' hidingPriority={0} allowHiding={true} />


        </DataGrid>
      </ValidationGroup>
    </div>
  );
};
